var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.81 3.94003C20.5 7.21003 17.51 11.48 14.66 14.27C14.25 11.69 12.19 9.67003 9.59003 9.31003C12.39 6.45003 16.69 3.42003 19.97 2.10003C20.55 1.88003 21.13 2.05003 21.49 2.41003C21.87 2.79003 22.05 3.36003 21.81 3.94003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.78 15.09C13.58 15.26 13.38 15.43 13.18 15.59L11.39 17.02C11.39 16.99 11.38 16.95 11.38 16.91C11.24 15.84 10.74 14.85 9.93 14.04C9.11 13.22 8.08999 12.72 6.97 12.58C6.94 12.58 6.9 12.57 6.87 12.57L8.31999 10.74C8.45999 10.56 8.61 10.39 8.77 10.21L9.44999 10.3C11.6 10.6 13.33 12.29 13.67 14.43L13.78 15.09Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.43 17.62C10.43 18.72 10.01 19.77 9.21001 20.56C8.60001 21.18 7.78001 21.6 6.78001 21.72L4.33001 21.99C2.99001 22.14 1.84001 20.99 1.99001 19.64L2.26001 17.18C2.50001 14.99 4.33001 13.59 6.27001 13.55C6.46001 13.54 6.67001 13.55 6.87001 13.57C7.72001 13.68 8.54001 14.07 9.23001 14.75C9.90001 15.42 10.28 16.21 10.39 17.04C10.41 17.24 10.43 17.43 10.43 17.62Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.a3e341307c4cb09ebd78d4798290b747.svg";
export { ForwardRef as ReactComponent };